import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WidgetHeader from '../Widget/WidgetHeader';
import AnswerButton from '../../components/Assessment/AnswerButton';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import ShareDrawer from '../../components/ShareDrawer';

import { isLongText } from '../../components/Shared/commonFunctions';

import { onGoToForm } from './actions.js';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import { Container, RockTheVoteLabel } from '../DefaultStyles/Details';
import {
    Body,
    Footer,
    Title,
    Content,
    Description,
    DetailsContainer,
    Details
} from '../DefaultStyles/Shared';

import { setOverlayPartnerVisible } from '../Widget/actions';

import rockTheVoteLogo from '../../assets/images/rock-the-vote-logo.png';
import { RockTheVoteDetails } from '../../components/Shared/rockTheVoteDetails';

class CheckRegistrationStart extends React.Component {
    componentDidMount() {
        this.forceUpdate();
    }
    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner
                    transitionType="right-to-left"
                    logo={rockTheVoteLogo}
                    name={this.props.rockTheVoteTitle}
                    description={this.props.rockTheVoteDescription}
                />
                <Body>
                    <WidgetHeader />
                    <Content isContactAction={false} isSingleAction={true}>
                        <Title
                            isLongText={isLongText(this.props.title, 60)}
                            isExtraLongText={isLongText(this.props.title, 95)}
                            onClick={e => this.props.setOverlayPartnerVisible(true, e, false)}
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                            }}
                        />
                        <DetailsContainer>
                            <Details>
                                <Description
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, false)
                                    }
                                    isLongText={isLongText(this.props.subTitle, 90)}
                                    isExtraLongText={isLongText(this.props.subTitle, 160)}
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.subTitle
                                    }}
                                />
                                <RockTheVoteLabel
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, true)
                                    }
                                >
                                    {this.props.rockTheVoteLabel}
                                </RockTheVoteLabel>
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <AutoScalingButtonSet mobileStyled={true} mobileLeftPosition={8}>
                        <AnswerButton
                            text={this.props.registerButtonText}
                            useLoadingSpinner={false}
                            onClick={() => {
                                this.props.onGoToForm(
                                    this.props.actionIdentifier,
                                    this.props.actionInitiated
                                );
                            }}
                        />
                    </AutoScalingButtonSet>
                    <Footer>
                        <ShareDrawer backgroundColor={'#fff'} />
                    </Footer>
                </Body>
            </Container>
        );
    }
}

CheckRegistrationStart.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    actionIdentifier: PropTypes.string.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    rockTheVoteLabel: PropTypes.string,
    rockTheVoteTitle: PropTypes.string,
    rockTheVoteDescription: PropTypes.string,
    registerButtonText: PropTypes.string.isRequired,
    onGoToForm: PropTypes.func.isRequired
};

export default connect(
    state => {
        const defaultTitle = 'Check to see if you are registered to vote.';
        const defaultText = `Unsure of your registration status? Take a minute to verify that you are all set for this year's elections.`;
        const defaultButtonText = `VERIFY`;

        return {
            title: state.widget.activeAction.title || defaultTitle,
            subTitle: state.widget.activeAction.text || defaultText,
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.checkRegistration.actionInitiated,
            rockTheVoteTitle: RockTheVoteDetails.title,
            rockTheVoteDescription: RockTheVoteDetails.description,
            rockTheVoteLabel: RockTheVoteDetails.label,
            registerButtonText:
                state.widget.activeAction.customButtonText || defaultButtonText
        };
    },
    {
        setOverlayPartnerVisible,
        onGoToForm
    }
)(CheckRegistrationStart);



// WEBPACK FOOTER //
// ./src/containers/CheckRegistration/CheckRegistrationStart.jsx